@if (stammteamData && stammteamData.length > 0) {
  <div class="my-header">
    <div class="left-group">
      <div>
        <mbsc-calendar-prev></mbsc-calendar-prev>
        <mbsc-calendar-today></mbsc-calendar-today>
        <mbsc-calendar-next></mbsc-calendar-next>
      </div>
      <!--
      <mbsc-select
        class="team-select"
        inputStyle="outline"
        [(ngModel)]="openTeams"
        placeholder="Team auswählen"
        [data]="myData"
        [touchUi]="false"
        (valueChange)="showOnlyTeam($event)"
        [ngClass]="getTeamClass(openTeams)"
        [ngClass]="[themeService.isDarkMode ? 'darkmode' : '', getTeamClass(openTeams)]"
        [selectMultiple]="true">
      </mbsc-select>
      -->
      <div class="filter-container">
        <mbsc-select
          class="filter-select"
          inputStyle="outline"
          [(ngModel)]="selectedEventFilter"
          placeholder="Eventfilter auswählen"
          [data]="eventFilter"
          [touchUi]="false"
          (valueChange)="filterEvents($event)"
          [selectMultiple]="true"
          [ngClass]="themeService.isDarkMode ? 'darkmode' : ''"
          >
        </mbsc-select>
        <mbsc-button
          class="team-btn"
          variant="outline"
          (click)="openAnchored($event)">
          Team Anordnung
        </mbsc-button>
        <mbsc-popup
          #teamOrderPopupAnchored
          [anchor]="teamOrderpopupAnchor"
          [options]="popupOptions">
          <div class="mbsc-padding">
            <div
              cdkDropList
              class="team-drop-list"
              [cdkDropListData]="teamOrderList"
              (cdkDropListDropped)="dropTeam($event)">
              @for (team of teamOrderList; track team) {
                <div
                  class="team-item"
                  cdkDrag
                  [cdkDragDisabled]="isFixed(team)"
                  [class.fixed]="isFixed(team)"
                  [ngStyle]="{ 'background-color': getTeamColor(team.id) }">
                  @if (isFixed(team)) {
                    <span class="lock-icon">📌</span>
                  }
                  <span class="team-name">
                    {{ team.name }}
                  </span>
                  <!-- Fix / Unfix Button -->
                  @if (!isFixed(team)) {
                    <mbsc-button
                      size="small"
                      variant="flat"
                      (click)="fixTeamFromPopup(team)">
                      <img
                        src="https://assets.tridimo.de/fontawesome/svgs/regular/thumbtack-angle.svg"
                        alt="Fixieren"
                        class="int-icon"
                        title="Spalte fixieren" />
                      </mbsc-button>
                    }
                    @if (isFixed(team)) {
                      <mbsc-button
                        size="small"
                        variant="flat"
                        (click)="unfixTeamFromPopup(team)">
                        <img
                          src="https://assets.tridimo.de/fontawesome/svgs/regular/thumbtack-angle-slash.svg"
                          alt="Entfixieren"
                          class="int-icon"
                          title="Spalte entfixieren" />
                        </mbsc-button>
                      }
                    </div>
                  }
                </div>
                <div class="popup-actions">
                  <mbsc-button
                    variant="outline"
                    color="danger"
                    (click)="teamOrderPopupAnchored.close()">
                    Abbrechen
                  </mbsc-button>
                  <mbsc-button (click)="saveTeamOrder()">
                    Speichern
                  </mbsc-button>
                </div>
              </div>
            </mbsc-popup>
          </div>
          <div class="filter-container">
            <!-- LEGENDE -->
            <mbsc-button
              class="team-btn"
              variant="outline"
              (click)="openLegendPopup($event)"
              >
              Legende
            </mbsc-button>
            <mbsc-popup
              class="legend-popup"
              #legendPopupAnchored
              [anchor]="legendpopupAnchor"
              [options]="legendAnchoredOptions">
              <div class="legend-container">
                <span>LEGENDE</span>
                <!-- <div class="legend-items-container"> -->
                <div class="legend-item">
                  <!-- INFO-ICONS -->
                  <span class="legend-item-header">Icons</span>
                  @for (icon of svgIconService.svgCache| keyvalue; track icon) {
                    <div class="icon-item">
                      <div class="info-icon" [innerHTML]="icon.value"></div>
                      <span>{{ svgIconService.getSvgName(icon.key) }}</span>
                    </div>
                  }
                </div>
              </div>
              <div class="popup-actions">
                <mbsc-button
                  variant="outline"
                  color="danger"
                  (click)="legendPopupAnchored.close()">
                  Schließen
                </mbsc-button>
              </div>
            </mbsc-popup>
          </div>
        </div>
        <div class="right-group">
          <div class="zoom-controls">
            <mbsc-button
              icon="minus"
              variant="flat"
              [disabled]="zoomLevel === 1"
              (click)="handleZoom(zoomLevel - 1)">
            </mbsc-button>
            <input
              type="range"
              min="1"
              max="3"
              [(ngModel)]="zoomLevel"
              (input)="handleInput($event)" />
              <mbsc-button
                icon="plus"
                variant="flat"
                [disabled]="zoomLevel === 3"
                (click)="handleZoom(zoomLevel + 1)">
              </mbsc-button>
            </div>
          </div>
        </div>
      }
